import { cn } from '@/lib/cn';

export type AnswerBlockOption = {
  content: {
    title?: string;
    description: string;
  };
  skip?: number;
  value: string;
};

export type OptionsProps = {
  options: AnswerBlockOption[];
  selection: string[];
  handleSelectOption: (value: string, isSelected: boolean) => void;
};

const Options = ({ options, selection, handleSelectOption }: OptionsProps) => {
  return options.map(({ content, value }, index) => (
    <div
      key={index}
      id={`answer-option-${index}`}
      className={cn(
        'bg-surface-default border-outline-default w-full cursor-pointer rounded-lg border px-4 py-3 hover:opacity-65',
        {
          'border-primary': selection?.includes(value)
        }
      )}
      onClick={() => handleSelectOption(value, selection.includes(value))}
    >
      {content?.title && <p className='text-content-title mb-0! text-base font-semibold'>{content.title}</p>}

      <p
        className={cn('mb-0! text-sm', { 'text-content-body': content?.title, 'text-content-title': !content?.title })}
      >
        {content.description}
      </p>
    </div>
  ));
};

export default Options;
